/* @flow */
import React, { useEffect, useState } from 'react';
import type { Node } from 'react';
import { useSelector } from 'react-redux';
import {
	RankWrapper,
	RankItem,
	RankNumber,
	RankText,
	RankDescription,
	RankImage,
	MobilePopup,
	MobilePopupWrapper,
	MobilePopupOverflow,
	MobilePopupClose,
	RankInfoWrapper,
} from './styles';
import smallFlat from '../../../../../public/images/home/presets/small-flat.png';
import smallFlat2x from '../../../../../public/images/home/presets/small-flat@2x.png';
import smallFlat3x from '../../../../../public/images/home/presets/small-flat@3x.png';

import { TWishesTextsItem } from '../../../../types/lexs';
import type { TRootState } from '../../../../types/rootState';
import { lockScroll, unlockScroll } from '../../../../DOMUtils';
import WishContent from './WishContent';
import { Popover } from '../../../Tooltip/Tooltip';

type TRankPlace = {
	rankPlace: number,
	relevancePercent: number,
	wishesTexts: TWishesTextsItem,
	withIcon?: boolean,
};

const RankPlaceRelevance = ({ rankPlace, relevancePercent, wishesTexts, withIcon }: TRankPlace): Node => {
	const isMobile: boolean = useSelector((state: TRootState) => state.app.isMobile);
	const [modalContent, setModalContent] = useState(null);
	const [showRelevance, setShowRelevance] = useState(false);

	useEffect(() => {
		if (modalContent) {
			lockScroll();
		} else {
			unlockScroll();
		}
	}, [modalContent]);

	const titlePlusMinus = {
		plus: 'Плюсы',
		minus: 'Минусы',
	};

	return (
		<RankWrapper $single={!rankPlace}>
			{withIcon && (
				<RankImage>
					<img src={smallFlat} srcSet={`${smallFlat}, ${smallFlat2x} 2x, ${smallFlat3x} 3x`} alt="" />
				</RankImage>
			)}
			<RankInfoWrapper>
				<RankItem id="percent">
					<RankNumber>{relevancePercent}%</RankNumber>
					<RankText>соответствие&nbsp;пожеланиям</RankText>
				</RankItem>
				{rankPlace && (
					<RankItem id="place" isGreen>
						<RankNumber $topPlace={rankPlace <= 10}>#{rankPlace}</RankNumber>
						<RankText>в&nbsp;вашей&nbsp;подборке</RankText>
					</RankItem>
				)}
				{isMobile ? (
					<RankDescription
						onClick={() =>
							setModalContent(
								<WishContent
									relevancePercent={relevancePercent}
									wishesTexts={wishesTexts}
									titlePlusMinus={titlePlusMinus}
								/>,
							)
						}
					>
						Что это значит?
					</RankDescription>
				) : (
					<Popover
						visible={showRelevance}
						onClickOutside={() => setShowRelevance(false)}
						onHidden={() => setShowRelevance(false)}
						content={
							<WishContent
								relevancePercent={relevancePercent}
								wishesTexts={wishesTexts}
								titlePlusMinus={titlePlusMinus}
							/>
						}
						appendTo={() => document.body}
						theme="rank"
						placement="bottom"
					>
						<RankDescription onClick={() => setShowRelevance(true)}>Что это значит?</RankDescription>
					</Popover>
				)}
			</RankInfoWrapper>

			{isMobile && modalContent && (
				<MobilePopup>
					<MobilePopupOverflow onClick={() => setModalContent(null)} />
					<MobilePopupWrapper $isShow={isMobile && modalContent}>
						<MobilePopupClose onClick={() => setModalContent(null)}>
							<span aria-hidden="true">&times;</span>
						</MobilePopupClose>
						{modalContent}
					</MobilePopupWrapper>
				</MobilePopup>
			)}
		</RankWrapper>
	);
};

RankPlaceRelevance.defaultProps = {
	withIcon: true,
};

export default RankPlaceRelevance;
